import { T } from '@salecycle/experimental/Typography/Typography';
import { Icon, LinkButton } from '@salecycle/ui-component-library';
import { useNavigateToEmailTemplates } from 'sections/bulk-retargeting-campaigns/CampaignEditor/hooks/useNavigateToEmailTemplates';
import { useTheme } from 'styled-components';
import { SubjectLineSelect } from './SubjectLineSelect';
import { useTranslation } from 'react-i18next';
import { useCampaignEditorContext } from '../../../state/hooks/useCampaignEditorContext';
import { TargetAudienceType } from 'sections/bulk-retargeting-campaigns/CampaignEditor/state/CampaignEditorState';

export interface SubjectLineProps {
  targetAudience: TargetAudienceType;
}

export const SubjectLine = ({ targetAudience }: SubjectLineProps) => {
  const theme = useTheme();
  const { t } = useTranslation('campaigns');
  const { state } = useCampaignEditorContext();

  const navigateToEmailTemplates = useNavigateToEmailTemplates();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: theme.designToken.spacing4 }}>
      <T variant="headingH3">{t('bulkRetargetingCampaigns.editor.subjectLine')}</T>
      <SubjectLineSelect targetAudience={targetAudience} />
      <div>
        <LinkButton
          ariaLabel={t('bulkRetargetingCampaigns.editor.manageSubjectLines')}
          onClick={navigateToEmailTemplates(true)}
          disabled={state?.readOnly}
        >
          {t('bulkRetargetingCampaigns.editor.manageSubjectLines')}
          <div style={{ marginLeft: theme.designToken.spacing1 }} />
          <div style={{ position: 'relative', margin: 'auto 0', top: '0', bottom: '0' }}>
            <Icon icon="external-link-square" />
          </div>
        </LinkButton>
      </div>
    </div>
  );
};
